<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? '编辑' : '新增'"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item name="appName" label="应用名称" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model:value="editForm.appName" placeholder="请输入" v-trim />
      </a-form-item>
      <a-form-item name="subdomain" label="目标系统" :rules="[{ required: true, message: '请选择' }]">
        <CosSelect
          v-model:value="editForm.subdomain"
          :options="[
            { label: '谷仓', value: 'cos_fbu' },
            { label: '云途', value: 'cos_lbu' }
          ]"
          placeholder="请选择"
          allow-clear
        />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref } from 'vue'
import { saveAppid, updateAppid } from '@/api/marketing/marketingManage'
import type { FormInstance } from 'ant-design-vue'
import { AppidSubmitParams } from '@/typings/api/marketingManage'
import { DcMessage } from '@dc-platform/dc-components'

export default { name: 'editModal' }
</script>
<script setup lang="ts">
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<AppidSubmitParams>({})
const emit = defineEmits(['success'])
const toggle = (row?: AppidSubmitParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true

    try {
      if (editForm.value.id) {
        await updateAppid({ ...editForm.value })
      } else {
        await saveAppid({ ...editForm.value })
      }
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? '编辑成功' : '新增成功')
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss"></style>
